import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Droplets, LogOut } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center">
          <img src="/logo.png" alt="Flash Property Solutions" className="h-12 w-auto" />
        </Link>

        <nav className="flex items-center gap-1.5">
          {user ? (
            <>
              <Link
                to="/contractor"
                data-testid="nav-dashboard"
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  location.pathname === "/contractor"
                    ? "text-sky-600 bg-sky-50"
                    : "text-slate-600 hover:text-slate-900"
                }`}
              >
                Dashboard
              </Link>
              <Link
                to="/contractor/invoices"
                data-testid="nav-invoices"
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  location.pathname.startsWith("/contractor/invoices")
                    ? "text-sky-600 bg-sky-50"
                    : "text-slate-600 hover:text-slate-900"
                }`}
              >
                Invoices
              </Link>
              <button
                data-testid="nav-logout"
                onClick={() => {
                  logout();
                  navigate("/login");
                }}
                className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-red-500 rounded-md flex items-center gap-1.5 transition-colors"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/"
                data-testid="nav-request"
                className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 rounded-md transition-colors"
              >
                Request a Job
              </Link>
              <Link
                to="/login"
                data-testid="nav-login"
                className="px-4 py-2 text-sm font-medium bg-sky-500 text-white rounded-md hover:bg-sky-600 transition-colors"
              >
                Contractor Login
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
